import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { resolveMallBasePath, useMallStandaloneNav } from '@/hooks/web/useMallStandaloneNav'

/** promotion 独立窗基路径 */
export function resolvePromotionBasePath(currentPath: string): string {
  if (currentPath.startsWith('/ai-Application-center/')) {
    return '/ai-Application-center/promotion'
  }
  return '/promotion'
}

/** 活动列表在 promotion 独立窗下的 path（相对 promotion 根） */
export const PROMOTION_ACTIVITY_LIST_PATH = '/activity/activity-list'

/**
 * 活动列表 / 编辑 / 详情 / 预览跳转
 * - promotion 独立窗：/ai-Application-center/promotion/activity/*
 * - mall 旧路径：/mall/promotion/game-lottery/activity/*
 */
export function usePromotionActivityNav() {
  const route = useRoute()
  const router = useRouter()
  const { pushMall } = useMallStandaloneNav()

  const inPromotionModule = computed(() => {
    const p = route.path
    return (
      (p.startsWith('/promotion/') || p.startsWith('/ai-Application-center/promotion/')) &&
      !p.includes('/mall/')
    )
  })

  const promotionBase = computed(() => resolvePromotionBasePath(route.path))

  function pushActivityRelative(
    subPath: string,
    extraQuery?: Record<string, string | number | undefined>
  ) {
    const normalized = subPath.startsWith('/') ? subPath : `/${subPath}`
    const query: Record<string, any> = { ...route.query }
    if (extraQuery) {
      for (const [k, v] of Object.entries(extraQuery)) {
        if (v === undefined) delete query[k]
        else query[k] = v
      }
    }
    if (inPromotionModule.value) {
      return router.push({ path: `${promotionBase.value}${normalized}`, query })
    }
    const mallBase = resolveMallBasePath(route.path)
    const mallPath = normalized
      .replace(PROMOTION_ACTIVITY_LIST_PATH, '/promotion/game-lottery/activity-manage')
      .replace(/^\/activity\//, '/promotion/game-lottery/activity/')
    return router.push({ path: `${mallBase}${mallPath}`, query })
  }

  const goList = () => pushActivityRelative(PROMOTION_ACTIVITY_LIST_PATH)
  const goEdit = (id?: number) => {
    if (typeof id === 'number') {
      return pushActivityRelative(`/activity/edit/${id}`)
    }
    return pushActivityRelative('/activity/activity-market')
  }
  const goDetail = (id: number) => pushActivityRelative(`/activity/detail/${id}`)
  const goPreview = (id: number) => pushActivityRelative(`/activity/preview/${id}`)

  return { goList, goEdit, goDetail, goPreview, pushActivityRelative, inPromotionModule }
}
